"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGetMyEnquiriesResponseDataDto = instanceOfGetMyEnquiriesResponseDataDto;
exports.GetMyEnquiriesResponseDataDtoFromJSON = GetMyEnquiriesResponseDataDtoFromJSON;
exports.GetMyEnquiriesResponseDataDtoFromJSONTyped = GetMyEnquiriesResponseDataDtoFromJSONTyped;
exports.GetMyEnquiriesResponseDataDtoToJSON = GetMyEnquiriesResponseDataDtoToJSON;
exports.GetMyEnquiriesResponseDataDtoToJSONTyped = GetMyEnquiriesResponseDataDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var MyEnquiryListItemDto_1 = require("./MyEnquiryListItemDto");
/**
 * Check if a given object implements the GetMyEnquiriesResponseDataDto interface.
 */
function instanceOfGetMyEnquiriesResponseDataDto(value) {
    if (!('enquiries' in value) || value['enquiries'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    return true;
}
function GetMyEnquiriesResponseDataDtoFromJSON(json) {
    return GetMyEnquiriesResponseDataDtoFromJSONTyped(json, false);
}
function GetMyEnquiriesResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enquiries': (json['enquiries'].map(MyEnquiryListItemDto_1.MyEnquiryListItemDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function GetMyEnquiriesResponseDataDtoToJSON(json) {
    return GetMyEnquiriesResponseDataDtoToJSONTyped(json, false);
}
function GetMyEnquiriesResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'enquiries': (value['enquiries'].map(MyEnquiryListItemDto_1.MyEnquiryListItemDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
